// extracted by mini-css-extract-plugin
export default {"Sidebar":"sidebar_Sidebar__oTryz","SidebarContent":"sidebar_SidebarContent__Wjj1W","SidebarContentMobileExpanded":"sidebar_SidebarContentMobileExpanded__sbOtb"};